import React, { memo, Suspense, useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { context } from '../../../globalState/GlobalState';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import './css/Events1.css';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import EventsNavBar1 from './EventsNavBar1';
import Title4 from '../../uiElements/title/title4/Title4';
import EventsEvents1 from './EventsEvents1';

const Events1 = (props) => {
    const { upcomingEvents, pastEvents, loadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb="Events" marginLeft="100px" />
                    <div className="events1-container-container x-center p-t-20px p-b-20px p-l-50px p-r-50px m-b-20px">
                        <Title4 title="Events" />
                        <div className="events1-container m-t-0">
                            <EventsNavBar1>
                                <Suspense fallback={<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />}>
                                    <Switch>
                                        <Route path="/events/upcoming" exact render={() => { return <EventsEvents1 events={upcomingEvents} loadingSpinner={loadingSpinner} unavailableText="No Upcoming Events" />; }} />
                                        <Route path="/events/past" exact render={() => { return <EventsEvents1 events={pastEvents} loadingSpinner={loadingSpinner} unavailableText="No Past Events" />; }} />
                                        <Route render={() => { return <Redirect to={{ pathname: '/events/upcoming' }} />; }} />
                                    </Switch>
                                </Suspense>
                            </EventsNavBar1>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

Events1.propTypes = {
    upcomingEvents: PropTypes.array.isRequired,
    pastEvents: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Events1);
